import type { AllEffect } from '@redux-saga/core/effects';
import { takeEvery } from 'containers/ErrorBoundary';
import { withCallback } from 'redux-saga-callback';
import { all, call } from 'redux-saga/effects';
import type { ApiRequestAction } from './actions';
import { API_REQUEST } from './constants';
import { requestForSaga } from './request';

function* apiRequestSaga(action: ApiRequestAction): Generator<any> {
  // https://ipfabric.atlassian.net/browse/NIM-5912
  return yield call(requestForSaga, action.payload);
}

export function* requestSagas(): Generator<AllEffect<unknown>, void> {
  yield all([takeEvery(API_REQUEST, withCallback(apiRequestSaga))]);
}
